import { FunctionComponent, useContext, useEffect, useState } from 'react';
import classnames from 'classnames';

import { Routes } from 'types/routes';

import Location from 'models/Location';

import { groupByKey } from 'utils/array';
import { withVariables } from 'utils/string';

import { list as listLocations } from 'requests/locations';

import MarketContext from 'components/context/Market';
import LayoutContainer from 'components/layout/LayoutContainer';

import StyledComponent from './styles';
import { Props } from './types';

export interface GroupedLocationCity {
    voivodeshipName: string;
    values: Location[];
}

const PublicSectionLocationsGroupedByVoivodeshipVariantDefault: FunctionComponent<Props> = ({ locations, translations, sectionSettings }) => {
    const [locationsListState, setLocationsListState] = useState<Location[]>(locations);
    const { productCategories } = useContext(MarketContext);
    const productCategorySlug = productCategories.find(category => category.id === sectionSettings?.filters?.category)?.locales[0]?.slug;

    const groupedLocationCities: GroupedLocationCity[] = Array.isArray(locationsListState) &&
        groupByKey('voivodeshipName', locationsListState.map(location => ({
            ...location,
            voivodeshipName: location.city?.voivodeship?.name,
        }))) || []
        .sort((a, b) => {
            return b.values.length - a.values.length;
        });

    useEffect(() => {
        listLocations({
            page: 1,
            perPage: 999,
            handlingByCategoryId: sectionSettings?.filters?.category,
        }).then(response => setLocationsListState(response?.elements));
    }, [!locationsListState, sectionSettings?.filters?.category]);

    return (
        <StyledComponent
            className="public-section-locations-grouped-by-voivodeship-variant-default"
        >
            <LayoutContainer>
                {translations?.headline && (
                    <div
                        className="headline"
                        dangerouslySetInnerHTML={{ __html: translations?.headline }}
                    />
                )}
                <div
                    className={classnames({
                        'groups': true,
                        'only-one-group': groupedLocationCities.length <= 1,
                    })}
                >
                    {groupedLocationCities.map(element => (
                        <div
                            key={element.voivodeshipName}
                            className="group"
                        >
                            <div className="group-title">
                                {element?.voivodeshipName}
                            </div>
                            <div className="group-values">
                                {element.values.map(value => (
                                    <a
                                        className="group-value"
                                        key={value.id}
                                        href={withVariables(Routes.PublicCategoryLocation, { categorySlug: productCategorySlug, slug: value.locale?.slug })}
                                    >
                                        <div className="value">
                                            {value.name}
                                        </div>
                                    </a>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </LayoutContainer>
        </StyledComponent>
    );
};

export default PublicSectionLocationsGroupedByVoivodeshipVariantDefault;
